module.exports = __webpack_public_path__ + "static/media/success2_500x620.4a13b7d0.jpg";